import i18n from '@/i18n';
import {UserGroup} from '@/services/graphqlHooks';

const userGroups: Record<UserGroup, string> = {
  [UserGroup.Superusers]: i18n.t('Superusers'),
  [UserGroup.Owners]: i18n.t('Owners'),
  [UserGroup.Admins]: i18n.t('Admins'),
  [UserGroup.Moderators]: i18n.t('Moderators'),
  [UserGroup.EmployeesInventory]: i18n.t('EmployeesWithInventory'),
  [UserGroup.EmployeesRehabilitation]: i18n.t('EmployeesWithRehabilitation'),
  [UserGroup.Employees]: i18n.t('Employees'),
  [UserGroup.AuthorizedRelatives]: i18n.t('AuthorizedRelatives'),
};

export default userGroups;
